// Age Verification Script for Cherry Dry Gin
document.addEventListener('DOMContentLoaded', function() {
  // Check if the cookie exists
  if (!getCookie('age_verified')) {
    showAgeVerification();
  }

  // Function to create and show the verification lightbox
  function showAgeVerification() {
    // Create the overlay
    const overlay = document.createElement('div');
    overlay.className = 'age-verification-overlay';
    
    // Create the modal
    const modal = document.createElement('div');
    modal.className = 'age-verification-modal';
    
    // Create the content
    modal.innerHTML = `
      <img src="https://floriservizio.it/cdn/shop/files/floriservizio_logo_1.png" alt="Floriservizio Logo" class="age-verification-logo">
      <h2>Age Verification</h2>
      <p style="font-family:Arial;">Are you 18 years or older?</p>
      <div class="age-verification-buttons">
        <button id="age-yes" class="age-button age-yes">YES</button>
        <button id="age-no" class="age-button age-no">NO</button>
      </div>
    `;
    
    // Append modal to overlay
    overlay.appendChild(modal);
    
    // Append overlay to body
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden'; // Prevent scrolling
    
    // Add event listeners
    document.getElementById('age-yes').addEventListener('click', function() {
      verifyAge(true);
    });
    
    document.getElementById('age-no').addEventListener('click', function() {
      verifyAge(false);
    });
  }
  
  // Function to handle verification response
  function verifyAge(isVerified) {
    if (isVerified) {
      // Set cookie for 30 days
      setCookie('age_verified', 'true', 30);
      // Remove the overlay
      const overlay = document.querySelector('.age-verification-overlay');
      if (overlay) {
        document.body.removeChild(overlay);
        document.body.style.overflow = ''; // Re-enable scrolling
      }
    } else {
      // Show denial message instead of redirecting
      const overlay = document.querySelector('.age-verification-overlay');
      const modal = document.querySelector('.age-verification-modal');
      
      // Update modal content
      modal.innerHTML = `
        <h2>Access Denied</h2>
        <p style="font-family:Arial;">Sorry, you must be 18 or older to view this content.</p>
        <div class="age-verification-buttons">
          <button id="age-try-again" class="age-button age-yes">Try Again</button>
        </div>
      `;
      
      // Add event listener to try again button
      document.getElementById('age-try-again').addEventListener('click', function() {
        // Remove current overlay
        if (overlay) {
          document.body.removeChild(overlay);
        }
        // Show verification again
        showAgeVerification();
      });
    }
  }
  
  // Helper function to set cookie
  function setCookie(name, value, days) {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
  }
  
  // Helper function to get cookie
  function getCookie(name) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
});